// styles
import styles from "../styles/PageHeading.module.css";
import ProgressBar from "./ProgressBar";

interface PageHeadingProps {
  title: string;
  text?: string;
  activeStep: number;
  setActiveStep: (step: number) => void;
  setEntryOptionSelected?: (entryOptionSelected: boolean) => void;
}

const PageHeading: React.FC<PageHeadingProps> = ({
  title,
  text,
  activeStep,
  setActiveStep,
  setEntryOptionSelected
}) => {
  return (
    <>
      {title &&
        <div className={styles.heading}>
          <h1 className={styles.title}>{title}</h1>
          {text && <p className={styles.text}>{text}</p>}
        </div>
      }
      <ProgressBar
        activeStep={activeStep}
        setEntryOptionSelected={setEntryOptionSelected}
        setActiveStep={setActiveStep}
      />
    </>
  )
};

export default PageHeading;
